import React from 'react';
import Rating from '@material-ui/lab/Rating';
import PropTypes from 'prop-types';

const FeedbackCard = (props) => {
  return (
    <div className="feedback-card">
      <Rating readOnly name="simple-controlled" value={5} />
      <h2 className="heading small-font">
        <q className="quote-text" id="feedback-heading">{props.text}</q>
      </h2>
    </div>
  );
};

FeedbackCard.propTypes = {
  text: PropTypes.string,
};

export default FeedbackCard;
